import { render, staticRenderFns } from "./StatusComponent.vue?vue&type=template&id=beb583fc&scoped=true"
import script from "./StatusComponent.vue?vue&type=script&lang=js"
export * from "./StatusComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb583fc",
  null
  
)

export default component.exports